export const treatmentTimeTypes = {
  specific: 'SpecificTime',
  timeslot: 'TimeSlots',
  multiple: 'MultipleVisitsPerDay',
};
